// UI/NotFound/notFound.jsx
import { Link, useLocation } from "react-router-dom"

const NotFound = () => {
	const location = useLocation()
	return (
		<section className="min-h-screen flex items-center justify-center bg-bg-page text-center px-6">
			<div>
				<p className="text-xs font-medium tracking-widest uppercase text-text-secondary mb-4">404</p>
				<h1 className="text-heading-lg font-bold text-text-primary mb-4">Page not found</h1>
				<p className="text-text-secondary mb-8">
					<span className="text-text-primary font-medium">{location.pathname}</span> doesn't exist or has been moved.
				</p>
				<Link to="/" className="px-6 py-3 rounded-component bg-brand-primary text-brand-text hover:bg-brand-hover transition-colors duration-quick text-sm font-medium">
					Go home
				</Link>
			</div>
		</section>
	)
}

export default NotFound
